import { IExportPlugin, PluginType } from '@/version-types';
import groupInnerPlugin from './group-inner-plugin';
import interactionPlugin from './interaction-plugin';

const pickPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 1,
    name: 'render-pick-layer',

    dependencies() {
        return [{ plugin: groupInnerPlugin }, { plugin: interactionPlugin }];
    },
};

export default pickPlugin;
